import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import CreateSingleVoyage from "@containers/singleVoyage/mutateVoyage/createVoyage/CreateSingleVoyage";

const CreateSingleVoyagePage = () => {

    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <CreateSingleVoyage/>
            </Suspense>
        </PageLayout>
    );
};

export default CreateSingleVoyagePage;